export default "__VITE_ASSET__BbvwAROA__"